import React from 'react'
import { Drawer } from 'antd'
import './index.scss'

const PaymentConfirmationModal = ({ isOpen, onCancel, link }) => {
  return (
    <Drawer placement="bottom" onClose={onCancel} open={isOpen}>
      {link && <iframe src={link} title="" width="100%" height="100%" />}
    </Drawer>
  )
}

export default PaymentConfirmationModal
